import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgAcknowledgement(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "acknowledgement_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#acknowledgement_svg__a)"
    }, {
      children: [_jsx("path", {
        d: "M15 33h5",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M15 22h5M25 33h24",
        stroke: "#FF6652",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M25 22h24",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M47.429 58.906l-.858 1.23.858-1.23zM31.273 47.657l.857-1.23-.857 1.23zM2.5 9v35.12h3V9h-3zm59 35.12V9h-3v35.12h3zM57 4.5H7v3h50v-3zM7 48.62h22.558v-3H7v3zm43 0h7v-3h-7v3zm-19.584.268L46.57 60.137l1.715-2.462L32.13 46.426l-1.714 2.462zM50.5 58.085V48.12h-3v9.966h3zm-3.928 2.052c1.657 1.154 3.928-.032 3.928-2.052h-3a.5.5 0 01.786-.41l-1.715 2.462zM50 45.619a2.5 2.5 0 00-2.5 2.5h3a.5.5 0 01-.5.5v-3zm-20.442 3a1.5 1.5 0 01.858.27l1.714-2.463a4.5 4.5 0 00-2.572-.807v3zM61.5 9A4.5 4.5 0 0057 4.5v3A1.5 1.5 0 0158.5 9h3zm-3 35.12a1.5 1.5 0 01-1.5 1.5v3a4.5 4.5 0 004.5-4.5h-3zm-56 0a4.5 4.5 0 004.5 4.5v-3a1.5 1.5 0 01-1.5-1.5h-3zM5.5 9A1.5 1.5 0 017 7.5v-3A4.5 4.5 0 002.5 9h3z",
        fill: "#7373FF"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgAcknowledgement;